import React from 'react';
import ReactDOM from 'react-dom';

import { whiteLabelPatchRoutes } from 'core/whitelabel';
import { configureRouter } from 'core/routing';

import { routes } from 'apps/routes';
import { Wikifactory } from 'apps/app';

configureRouter(whiteLabelPatchRoutes(routes), { defaultRoute: 'home' });
// If we wanted to have a global appManagers context object  we could potentially map
// appManagers here based on route and global stores.
// We could insert an appManagers Provider (context object).
// Hopefully that would allow us to initialise appManager Variable state before the first render is complete
ReactDOM.render(<Wikifactory />, document.getElementById('app'));
